import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useForgotPasswordMutation } from "store/auth/auth.api";
import "./index.scss";

const ForgotPasswordForm = () => {
  const { register, handleSubmit } = useForm();
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
  const { t } = useTranslation();

  const onSubmit = async (data) => {
    try {
      await forgotPassword({ email: data.email }).unwrap();
      toast.success(t("verif your email to reset password"));
    } catch (err) {
      // keep toast for errors
      toast.error(err?.data?.message || t("error_occurred"));
    }
  };

  return (
    <div className="reset-password-page">
      <h2 className="title">{t("login.reset_password")}</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input
          type="email"
          placeholder={t("login.email_placeholder")}
          {...register("email")}
        />
        <button type="submit" disabled={isLoading}>
          {t(isLoading ? "login.verifying" : "login.send")}
        </button>
      </form>
    </div>
  );
};

export default ForgotPasswordForm;
